import { render, staticRenderFns } from "./EditPersonAddressDialog.vue?vue&type=template&id=6b21a6dc&scoped=true&"
import script from "./EditPersonAddressDialog.vue?vue&type=script&lang=js&"
export * from "./EditPersonAddressDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b21a6dc",
  null
  
)

export default component.exports